function getProductPriceNameFromData(element: HTMLElement, keepCurrencySymbol: boolean = false) {

	const { price, name } = element.dataset;
	const productName = name || '';
	let productPrice = price ? `${price.split('.')[0]}.${price.split('.')[1].slice(0, 2)}` : '';

	if (productPrice.indexOf('$') > -1 && !keepCurrencySymbol) {

		productPrice = productPrice.replace('$', '');

	}

	return [productPrice, productName];

}

export default getProductPriceNameFromData;
